import { cn } from '@/lib/core/utils/cn';
import { Icon } from '@/components/ui/icon';

export interface FormRowProps {
  label: string;
  value?: string;
  isEmpty: boolean;
  disabled?: boolean;
  onClick: () => void;
  showArrow?: boolean;
  valueClassName?: string;
}

export function FormRow({
  label,
  value,
  isEmpty,
  disabled = false,
  onClick,
  showArrow = true,
  valueClassName,
}: FormRowProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={cn(
        'flex w-full border-b border-[#e5e5e5] text-left',
        disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        isEmpty ? 'items-center gap-4 pt-4 pb-6' : 'flex-col gap-4 pb-4'
      )}
    >
      {!isEmpty && (
        <span
          className={cn(
            'font-pp-neue-montreal text-[12px] font-semibold tracking-[1px] uppercase',
            disabled ? 'text-[#A9A9A9]' : 'text-[#818181]'
          )}
        >
          {label?.replace('?', '')}
        </span>
      )}
      <div className="flex w-full items-center gap-4">
        <span
          className={cn(
            'font-pp-neue-montreal flex-1 text-left text-[28px] tracking-[0.5px]',
            isEmpty
              ? disabled
                ? 'font-medium text-[#D9D9D9]'
                : 'font-medium text-[#A9A9A9]'
              : disabled
                ? 'font-normal text-[#D9D9D9]'
                : 'font-normal text-black',
            valueClassName
          )}
        >
          {isEmpty ? label : value}
        </span>
        {showArrow && !disabled && (
          <Icon
            name="nav-arrow-down"
            width={18}
            height={18}
            strokeWidth={1.5}
            className="shrink-0 text-[#7D7D7DB2]"
          />
        )}
      </div>
    </button>
  );
}
